module.exports = __webpack_public_path__ + "img/藏菖蒲.a9afc0f9.jpg";